"use strict";

exports.__esModule = true;
exports.UserClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _cookie = require("@tajawal/web-core-sdk-v2/lib/services/cookie.service");
var _constants = require("../constants");
// @todo  need to set it from middle ware from vertical
const token = _cookie.$cookie.get(_constants.STORAGE_KEYS.AUTH_TOKEN);
token && _http.$http.addHeaders({
  Authorization: `Bearer ${_cookie.$cookie.get(_constants.STORAGE_KEYS.AUTH_TOKEN)}`
});
const UserClient = {
  /**
   * @returns {Promise}
   * @description Return user info based on Authorization header
   */
  profile() {
    const requestId = 'ME';
    const endPoint = _constants.ENDPOINTS.ME;
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   *
   * @param {string} userId
   * @param {Object} user
   * @param {string} user.Title
   * @param {string} user.FirstName
   * @param {string} user.MiddleName
   * @param {string} user.LastName
   * @param {boolean} user.isEnabled
   * @param {boolean} user.isGuest
   * @param {string} user.role
   *
   * @returns {Promise}
   *
   * @description Update the user based on userId
   */
  updateProfile(userId, user) {
    const requestId = 'UPDATE_USER';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.USER, {
      userId
    });
    return _http.$http.put(requestId, endPoint, {
      data: user
    }).then(({
      data
    }) => data);
  },
  /**
   *
   * @param {payload.attachment} attachment
   * @param {payload.fileName} fileName
   *
   * @returns {Promise}
   *
   * @description submit promo attachment
   */
  submitPromo(payload) {
    const requestId = 'SUBMIT_PROMO';
    return _http.$http.post(requestId, _constants.ENDPOINTS.SUBMIT_PROMO, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   *
   * @returns {Promise}
   *
   * @description link order
   */

  claimUserPoints() {
    const requestId = 'USER_LINK_ORDER';
    const endPoint = _constants.ENDPOINTS.USER_LINK_ORDER;
    return _http.$http.post(requestId, endPoint, {}).then(({
      data
    }) => data);
  },
  /**
   *
   * @returns {Promise}
   *
   * @description delete user account
   */
  deleteAccount(payload) {
    const requestId = 'DELETE_ACCOUNT';
    return _http.$http.post(requestId, _constants.ENDPOINTS.DELETE_ACCOUNT, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * delete accont verify
   * @param {string} mode
   * @param {string} token
   * @param {string} requestId
   * @returns {Promise<unknown>}
   */
  deleteAccountVerify(data) {
    const reqId = 'VERIFY_USER_EMAIL';
    return _http.$http.post(reqId, _constants.ENDPOINTS.DELETE_ACCOUNT_VERIFY, {
      data
    }).then(({
      data
    }) => data);
  }
};
exports.UserClient = UserClient;